import styles from "./tetris-2-information.module.css";
export const TetrisTwo = ({ theme }) => {
      return (
            <div>
                  <h3
                        className={
                              styles["heading"] +
                              " " +
                              styles["heading-" + theme]
                        }
                  >
                        Introduction
                  </h3>
                  <div
                        className={
                              styles["content"] +
                              " " +
                              styles["content-" + theme]
                        }
                  >
                        Designed and developed a complete web-based Modern
                        falling blocks game. A remake from scratch of one of the
                        best games in the world. It attracted 450 visitors in
                        the first 25 days its public launch. It received{" "}
                        <a
                              href="https://x.com/runtimeerror55/status/1783817051921912245"
                              style={{
                                    color: "inherit",
                                    textDecoration: "underline",
                              }}
                        >
                              <b>
                                    {" "}
                                    overwhelmingly positive response from the
                                    users
                              </b>
                        </a>{" "}
                        and came{" "}
                        <a
                              href="https://peerlist.io/runtimeerror55/project/mtris"
                              style={{
                                    color: "inherit",
                                    textDecoration: "underline",
                              }}
                        >
                              <b>top 2 in peerlist project of the month.</b>
                        </a>
                  </div>

                  <h3
                        className={
                              styles["heading"] +
                              " " +
                              styles["heading-" + theme]
                        }
                  >
                        Game Modes
                  </h3>
                  <div
                        className={
                              styles["content"] +
                              " " +
                              styles["content-" + theme]
                        }
                  >
                        <p className={styles["p1"]}>
                              Get ready for an exhilarating Tetris experience
                              with two distinct game modes, each offering its
                              own set of challenges and excitement.
                        </p>
                        <ul>
                              <li>
                                    <b>Single Player:</b> embark on a solo
                                    journey to complete all the challenges of
                                    different difficulties and show your true
                                    skills.
                              </li>
                              <li>
                                    <b>split screen (2 Players):</b>
                                    invite a friend to join the fun! Experience
                                    the thrill of competitive Tetris with two
                                    players on the same screen, side by side.
                                    It's a test of skill and strategy as you aim
                                    to outlast and outscore your opponent. This
                                    mode is not supported in mobiles and small
                                    screens.
                              </li>
                        </ul>
                  </div>

                  <h3
                        className={
                              styles["heading"] +
                              " " +
                              styles["heading-" + theme]
                        }
                  >
                        In game controls
                  </h3>
                  <div
                        className={
                              styles["content"] +
                              " " +
                              styles["content-" + theme]
                        }
                  >
                        <ul>
                              <li>controller only support</li>
                              <li>controller and keyboard support</li>
                              <li> keyboard only support</li>
                              <li>upto 2 controllers are supported</li>
                              <li>
                                    you can change key bindings in the controls
                                    section.
                              </li>
                              <li>
                                    To see mutltiple controllers(mutltiple
                                    contollers should be connected) and
                                    mutltiple keyboards bindings(single
                                    connected keyboard is enough) you need to
                                    select 2 players split screen mode
                              </li>
                              <li>
                                    vibration support with compatible
                                    controllers. We tested using red gear pro
                                    wireless, cosmic byte nebula wireless.
                              </li>
                        </ul>
                  </div>

                  <h3
                        className={
                              styles["heading"] +
                              " " +
                              styles["heading-" + theme]
                        }
                  >
                        Naviagtion controls
                  </h3>
                  <div
                        className={
                              styles["content"] +
                              " " +
                              styles["content-" + theme]
                        }
                  >
                        <p className={styles["p1"]}>
                              Another big feature of our game is that you get
                              full contoller, keyboard, mouse and touch support
                              for navigating the whole game.
                        </p>
                        <ul>
                              <li>
                                    <b>controller:</b>
                              </li>

                              <ul>
                                    <li>
                                          use d-pad up and d-pad down buttons to
                                          navigate through options, to scroll
                                          guide page
                                    </li>
                                    <li>use X button to select an option</li>
                                    <li>
                                          use B button to go back to previous
                                          options
                                    </li>
                              </ul>
                        </ul>
                        <ul>
                              <li>
                                    <b
                                          className={
                                                styles["heading"] +
                                                " " +
                                                styles["heading-" + theme]
                                          }
                                    >
                                          keyboard:
                                    </b>
                              </li>

                              <ul>
                                    <li>
                                          use Arrow up and Arrow down keys to
                                          navigate through options,to scroll
                                          guide page
                                    </li>
                                    <li>use Enter key to select an option</li>
                                    <li>
                                          use backspace key to go back to
                                          previous options
                                    </li>
                              </ul>
                        </ul>
                  </div>

                  <h3
                        className={
                              styles["heading"] +
                              " " +
                              styles["heading-" + theme]
                        }
                  >
                        Scoring
                  </h3>
                  <div
                        className={
                              styles["content"] +
                              " " +
                              styles["content-" + theme]
                        }
                  >
                        <ul>
                              <li>1x shot: 100</li>
                              <li>2x shot: 400</li>
                              <li>3x shot: 900</li>
                              <li>4x shot: 1600</li>
                        </ul>
                  </div>

                  <h3
                        className={
                              styles["heading"] +
                              " " +
                              styles["heading-" + theme]
                        }
                  >
                        Skins
                  </h3>
                  <div
                        className={
                              styles["content"] +
                              " " +
                              styles["content-" + theme]
                        }
                  >
                        <p className={styles["p1"]}>
                              Explore our collection of carefully crafted skins,
                              each designed to elevate your gaming experience.
                              With different color schemes and minimalist
                              designs, there's a skin for every taste. Choose
                              the one that reflects your style and adds an extra
                              layer of enjoyment to your Tetris sessions.Our
                              skins are not just about aesthetics—they're
                              designed for optimal visual appeal. Crisp
                              graphics, seamless animations, and attention to
                              detail create a visually engaging environment.
                        </p>

                        <ul>
                              <li>Blue</li>
                              <li>Red</li>
                              <li>Green</li>
                              <li>Violet</li>
                              <li>Yellow</li>
                        </ul>
                  </div>

                  <h3
                        className={
                              styles["heading"] +
                              " " +
                              styles["heading-" + theme]
                        }
                  >
                        Requirements
                  </h3>
                  <div
                        className={
                              styles["content"] +
                              " " +
                              styles["content-" + theme]
                        }
                  >
                        <ul>
                              <li>
                                    single player is playable on mobiles as
                                    well.
                              </li>
                              <li>
                                    split screen is not playable on mobiles.It
                                    adjusts to every screen but it looks very
                                    small on very small screens.
                              </li>
                              <li>
                                    For performance we tested using snapdragon
                                    675(mobile), intel i3-1115G4(laptop). Gets
                                    close to 60fps on both.
                              </li>
                        </ul>
                  </div>
            </div>
      );
};
